<template>
	<div class="relative w-full py-10 md:px-10 bg-secondary-1 bg-opacity-70 overflow-hidden">
		<div class="relative w-full flex flex-col justify-center items-start gap-4 z-10 px-10 pb-32">
			<span class="text-xl md:text-2xl lg:text-3xl font-display">
				{{ $t('rentABike.title') }}
			</span>

			<p class="text-[17px] leading-[27px] md:max-w-[75%]">
				{{ $t('rentABike.text') }}
			</p>
		</div>

		<div ref="foldedBike" class="absolute bottom-0 left-0 pb-2 translate-x-1/4  opacity-20 hidden">
			<img src="/images/bike-folded.png" alt="Bike" class="w-52 max-w-[30vw]" />
		</div>

		<div ref="bike" class="absolute bottom-0 right-0 -translate-x-1/4  opacity-20 hidden">
			<img src="/images/bike.png" alt="Bike" class="w-80 max-w-[40vw] scale-x-[-1]" />
		</div>
	</div>
</template>

<script>
import { gsap } from 'gsap';

export default {
	name: 'RentBikePage',
	data() {
		return {
			bikeAnimated: false,
		};
	},
	mounted() {
		if (this.isInViewport()) {
			this.animateBike();
		}
		// when full height of this component is scrolled into view, animate the bike
		window.addEventListener('scroll', () => {
			if (this.isInViewport()) {
				this.animateBike();
			}
		});
	},
	methods: {
		isInViewport() {
			const { top, bottom } = this.$el.getBoundingClientRect();
			const { innerHeight } = window;

			return top < innerHeight && bottom > 0;
		},
		animateBike() {
			if (this.bikeAnimated) return;
			this.bikeAnimated = true;

			this.$refs.bike.classList.remove('hidden');
			this.$refs.foldedBike.classList.remove('hidden');

			this.$nextTick(() => {
				gsap.from(this.$refs.bike, {
					duration: 1,
					x: '100%',
					opacity: 0,
					ease: 'power1.out',
				});

				gsap.from(this.$refs.foldedBike, {
					duration: 1,
					x: '-100%',
					opacity: 0,
					ease: 'power1.out',
				});
			});
		},
	},
};
</script>
